import { render, staticRenderFns } from "./updateName.vue?vue&type=template&id=422dd7e4&scoped=true&"
import script from "./updateName.vue?vue&type=script&lang=js&"
export * from "./updateName.vue?vue&type=script&lang=js&"
import style0 from "./updateName.vue?vue&type=style&index=0&id=422dd7e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422dd7e4",
  null
  
)

export default component.exports